/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { TextStyleProps } from 'types';
import { buildParagraphTextStyle } from 'lib/buildTextStyle';
import styles from './ParagraphText.module.scss';

type TextProps = { children: React.ReactNode } & TextStyleProps;

export default function ParagraphText(props: TextProps) {
  const { children, ...rest } = props;

  return (
    <p
      className={styles.paragraphText}
      style={buildParagraphTextStyle(rest)}
    >
      {children}
    </p>
  );
}
